"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.programFamilyExists = exports.getAvailableProgramFamiliesForBusinessUnit = exports.getAvailableProgramFamilies = void 0;
var programFamilies_1 = require("../configs/programFamilies");
/**
 * Gets all available program families.
 */
var getAvailableProgramFamilies = function () { return Object.values(programFamilies_1.ProgramFamily); };
exports.getAvailableProgramFamilies = getAvailableProgramFamilies;
/**
 * Gets all available program families for a given business unit.
 * @param businessUnit
 */
var getAvailableProgramFamiliesForBusinessUnit = function (businessUnit) { return programFamilies_1.availableProgramFamiliesPerBusinessUnit[businessUnit]; };
exports.getAvailableProgramFamiliesForBusinessUnit = getAvailableProgramFamiliesForBusinessUnit;
/**
 * Checks if a given program family exists.
 * @param programFamily
 */
var programFamilyExists = function (programFamily) {
    return (0, exports.getAvailableProgramFamilies)().includes(programFamily);
};
exports.programFamilyExists = programFamilyExists;
